import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Pushes a virtual page view to the GTM dataLayer on every client-side
 * route change (React Router navigation). Pair with a GTM "Custom Event"
 * trigger on `virtual_page_view` and a GA4 Event tag to track SPA screens.
 *
 * Payload fields:
 *   - event:        'virtual_page_view'
 *   - page_path:    pathname + search (e.g. /tianjin/dashboard/students)
 *   - page_title:   document.title at push time
 *   - page_location: full URL
 */
function pushVirtualPageView(path) {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  window.dataLayer.push({
    event: 'virtual_page_view',
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });
}

function RouteTracker() {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    // Dedupe: skip if we already pushed for this exact path (e.g. StrictMode
    // double-mount or re-renders that don't change the URL)
    if (lastTracked.current === path) return;
    lastTracked.current = path;
    pushVirtualPageView(path);
  }, [location.pathname, location.search]);

  return null;
}

export default RouteTracker;
